import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import map from 'lodash/map';
import get from 'lodash/get';
import toLower from 'lodash/toLower';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import App from 'modules/App';
import { usePatientProfileForm } from '../hooks';
import styles from './PhiSetFormPartial.pcss';
const PhiSetFormPartial = ()=>{
    const localizationResources = useSelector(App.selectors.localizationResources);
    const { formValues, setFormValue } = usePatientProfileForm();
    const gender = get(formValues, 'values.gender');
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.phiSetFormPartial,
        children: [
            /*#__PURE__*/ _jsx(FormGroup, {
                id: "diabetesType",
                labelMessage: App.messages.labels.diabetesType,
                formValues: formValues,
                children: /*#__PURE__*/ _jsx(Select, {
                    optionsFrom: map(App.constants.DIABETES_TYPES, (value)=>({
                            value,
                            label: get(localizationResources, `diabetesType_${toLower(value)}.value`, value)
                        })),
                    hiddenValues: [
                        ...App.constants.DIABETES_TYPES_HIDE_FOR_PWD,
                        ...gender === 'Male' ? App.constants.DIABETES_TYPES_HIDE_FOR_MALE : []
                    ],
                    valueKey: "value",
                    labelKey: "label",
                    noValueMessage: App.messages.placeholders.diabetesType,
                    onChange: setFormValue
                })
            }),
            /*#__PURE__*/ _jsx(FormGroup, {
                id: "treatmentType",
                labelMessage: App.messages.labels.treatmentType,
                formValues: formValues,
                children: /*#__PURE__*/ _jsx(Select, {
                    optionsFrom: map(App.constants.TREATMENT_TYPES, (value)=>({
                            value,
                            label: get(localizationResources, `treatmentType_${toLower(value)}.value`, value)
                        })),
                    valueKey: "value",
                    labelKey: "label",
                    noValueMessage: App.messages.placeholders.treatmentType,
                    onChange: setFormValue
                })
            })
        ]
    });
};
export default PhiSetFormPartial;
